import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

import TDesign from 'tdesign-vue-next';
// 引入组件库的少量全局样式变量
import 'tdesign-vue-next/es/style/index.css';

import router from './router/main'
import Hiprint from 'vue-plugin-hiprint';
import {disAutoConnect} from 'vue-plugin-hiprint'
import TDesignChat from '@tdesign-vue-next/chat'; // 引入chat组件

disAutoConnect()
const app = createApp(App)
app.use(axios)
app.use(Hiprint)
app.use(router)
app.use(TDesign)
app.use(TDesignChat);

axios.defaults.withCredentials = true
// axios.defaults.baseURL = '/api'
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
app.config.globalProperties.$axios = axios

app.mount('#app')